import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

//internal import
import { notifySuccess, notifyError } from '../../utils/toast';
import Container from "./Container";

const Uploader = ({ setImageUrl, imageUrl, folder, multiple }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState("");


  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".webp"],
    },
    multiple: multiple,
    maxSize: 50000000,
    maxFiles: 10,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  useEffect(() => {
    if (fileRejections) {
      fileRejections.map(({ file, errors }) => (
        <li key={file.path}>
          {file.path} - {file.size} bytes
          <ul>
            {errors.map((e) => (
              <li key={e.code}>
                {e.code === "too-many-files"
                  ? notifyError(
                    `Maximum ${10} Image Can be Upload!`
                  )
                  : notifyError(e.message)}
              </li>
            ))}
          </ul>
        </li>
      ));
    }

    if (files) {
      files.forEach((file) => {

        if (
          multiple &&
          imageUrl?.length + files?.length >
          10
        ) {
          return notifyError(
            `Maximum ${10} Image Can be Upload!`
          );
        }
        setLoading(true);
        setError("Uploading....");
        if (multiple) {
          const result = imageUrl?.find(
            (img) => img === `${"https://api.cloudinary.com/v1_1/your_cloudinary_cloud_name/image/upload"}`
          );

          if (result) return setLoading(false);
        }
        // const name = file.name.replaceAll(/\s/g, "");
        // const public_id = name?.substring(0, name.lastIndexOf("."));

        const formData = new FormData();
        formData.append("files", file);
        // formData.append(
        //   "upload_preset",
        //   import.meta.env.VITE_APP_CLOUDINARY_UPLOAD_PRESET
        // );
        // formData.append("cloud_name", import.meta.env.VITE_APP_CLOUD_NAME);
        formData.append("folder", folder);
        // formData.append("public_id", public_id);
        let adminInfo;
        if (Cookies.get("adminInfo")) {
          adminInfo = JSON.parse(Cookies.get("adminInfo"));
        }
        axios({
          url: `${process.env.REACT_APP_API_BASE_URL}/common/uploads`,
          method: "POST",
          headers: {
            authorization: adminInfo ? `Bearer ${adminInfo.token}` : null,

            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: formData,
        })
          .then((res) => {
            notifySuccess("Image Uploaded successfully!");
            setLoading(false);
            if (multiple) {
              setImageUrl((imgUrl) => [...imgUrl, res.data.filePaths[0]]);
            } else {
              setImageUrl(res.data.filePaths[0]);
            }
          })
          .catch((err) => {
            console.error("err", err);
            notifyError(err.Message);
            setLoading(false);
          });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  const thumbs = imageUrl ? files.map((file) => (
    <div key={file.name}>
      <div>
        <img
          className="inline-flex border-2 border-gray-100 w-24 max-h-24"
          src={file.preview}
          alt={file.name}
          crossOrigin="anonymous"
        />
      </div>
    </div>
  )) : "";

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  const handleRemoveImage = async (img) => {
    try {
      setLoading(false);
      notifyError("Image delete successfully!");
      if (multiple) {
        const result = imageUrl?.filter((i) => i !== img);
        setImageUrl(result);
      } else {
        setImageUrl("");
      }
    } catch (err) {
      console.error("err", err);
      notifyError(err.Message);
      setLoading(false);
    }
  };

  return (
    <div className="w-100 text-center">
      <div
        className="border border-secondary border-dashed rounded p-4 cursor-pointer"
        style={{ borderStyle: 'dashed' }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <div className="d-flex justify-content-center mb-2">
          <FiUploadCloud size={32} className="text-success" />
        </div>
        <p className="small mb-1">DragYourImage</p>
        <em className="text-muted small">{"(Only *.jpeg, *.webp and *.png images will be accepted)"}</em>
      </div>

      <div className="text-success mt-2">{loading && err}</div>

      <div className="d-flex flex-wrap mt-3">
        {multiple ? (
          <DndProvider backend={HTML5Backend}>
            <Container
              setImageUrl={setImageUrl}
              imageUrl={imageUrl}
              handleRemoveImage={handleRemoveImage}
            />
          </DndProvider>
        ) : !multiple && imageUrl ? (
          <div className="position-relative me-3 mb-3">
            <img
              src={imageUrl}
              alt="Image"
              className="border rounded p-2"
              style={{ width: '96px', maxHeight: '96px' }}
              crossOrigin="anonymous"
            />
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0"
              onClick={() => handleRemoveImage(imageUrl)}
              aria-label="Remove image"
            >
              <FiXCircle className="text-danger" />
            </button>
          </div>
        ) : (
          thumbs
        )}
      </div>
    </div>
  );
};

export default Uploader;
